import { StateModel } from 'src/shared/models';
import {
  GET_DYNAMIC_CONV_FLOWS,
  GET_DYNAMIC_CONV_FLOWS_ERROR,
  GET_DYNAMIC_CONV_FLOWS_SUCCESS,
} from '../actions/dynamic-conv-flow.action';

const INITIAL_STATE: StateModel = {
  loading: false,
  loaded: false,
  error: null,
  data: {},
};

export const dynamicConvFlowReducer = (
  state: StateModel = INITIAL_STATE,
  { type, payload, error }: any,
) => {
  switch (type) {
    case GET_DYNAMIC_CONV_FLOWS:
      return {
        ...state,
        loaded: false,
        loading: true,
      };
    case GET_DYNAMIC_CONV_FLOWS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: payload.content,
      };
    case GET_DYNAMIC_CONV_FLOWS_ERROR:
      return {
        ...state,
        loading: false,
        loaded: false,
        error,
      };

    default:
      return state;
  }
};

export default dynamicConvFlowReducer;
